module.exports = __webpack_public_path__ + "images/pages/kaitori_bonus_cp_lp/february/mainvisual-bg-pc_692bdfd588bbbee1eaae738bc5ab45d7.png";